import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
declare var jquery: any;
declare var $: any;
declare var swal: any;

import { RestCallerService } from '../../common/services/rest-caller.service';


function confirmPassword(k: AbstractControl): any {
  if (k.get('password') === k.get('retypePassword')) {
    return { password: true };
  }
  return null;
}

function matchingPasswords(passwordKey: string, confirmPasswordKey: string) {
  return (group: FormGroup): { [key: string]: any } => {
    const password = group.controls[passwordKey];
    const confirmPassword = group.controls[confirmPasswordKey];
    if (password.value !== confirmPassword.value) {
      return {
        mismatchedPasswords: true
      };
    }
  }
}

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})


export class ResetPasswordComponent implements OnInit {
  showLoader: boolean;
  passwordResetForm: FormGroup;
  registrationForm: FormGroup;

  constructor(private router: Router,
    private restCallingService: RestCallerService,
    public fb: FormBuilder) { }

  ngOnInit() {
    this.showLoader = false;
    this.passwordResetForm = this.fb.group({
      'password': new FormControl(null, Validators.required),
      'retypePassword': new FormControl(null, [Validators.required])
    }, { validator: matchingPasswords('password', 'retypePassword') });

  }

  updatePassword() {
    this.showLoader = true;
    this.restCallingService.updatePassword(JSON.parse(sessionStorage.getItem('currentUser'))['username'],
      this.passwordResetForm.value['password']).subscribe(
      data => {
        this.showLoader = false;
        swal("Success!", "Password Updated! Will Redirect to Login Page.", "success");
        sessionStorage.clear();
        setTimeout(() => {
          this.router.navigate(['login']);
        }, 3000);
      },
      err => {
        this.showLoader = false;
        console.log(err.json());
        swal("Failure!", err.json().message, 'error');
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/account/reset-password/reset-password.component.ts